module.exports = __webpack_public_path__ + "static/media/HomeEasyAccess.02d0f724.svg";